import { render, staticRenderFns } from "./ManageVersion.vue?vue&type=template&id=65cd648c&scoped=true"
import script from "./ManageVersion.vue?vue&type=script&lang=js"
export * from "./ManageVersion.vue?vue&type=script&lang=js"
import style0 from "./ManageVersion.vue?vue&type=style&index=0&id=65cd648c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cd648c",
  null
  
)

export default component.exports